// src/components/BankApprovalTable.jsx
import React from "react";

const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"];

export default function BankApprovalTable({
  state,
  selectedIds,
  toggleAll,
  toggleOne,
  allChecked,
  someChecked,
  hasPendingForAction,
  performAction,
  handleCloseMonth,
  setShowRejectModal
}) {
  const { records, isMonthClosed, districtName, selectedMonth, selectedYear } = state;

  return (
    <table align="center" cellPadding="6" cellSpacing="0" width="98%"
      style={{ marginTop: "20px", border: "1px solid #000", fontFamily: "Arial", borderCollapse: "collapse" }}>

      <thead>
        <tr style={{ backgroundColor: "#000", color: "white" }}>
          <th colSpan="18" style={{ padding: "12px", fontSize: "17px", fontWeight: "bold" }}>
            Bank Details Approval for {districtName} ({monthNames[state.reportMonth - 1]} {state.reportYear})
          </th>
        </tr>
        <tr style={{ backgroundColor: "#000", color: "white" }}>
          <th rowSpan="2" width="100" style={{ padding: "10px" }}>
            {!isMonthClosed && hasPendingForAction && (
              <>
                Approve/Reject<br /><br />
                Select All <input type="checkbox" checked={allChecked} onChange={toggleAll}
                  ref={el => el && (el.indeterminate = someChecked)}
                  style={{ transform: "scale(1.2)" }} />
              </>
            )}
          </th>
          <th rowSpan="2" style={{ padding: "10px" }}>S.No</th>
          <th rowSpan="2" style={{ padding: "10px" }}>District</th>
          <th rowSpan="2" style={{ padding: "10px" }}>Office / Mandal</th>
          <th rowSpan="2" style={{ padding: "10px" }}>Shop No.</th>
          <th colSpan="6" style={{ padding: "10px" }}>Old Details</th>
          <th colSpan="6" style={{ padding: "10px" }}>New Details</th>
          <th rowSpan="2" style={{ padding: "10px" }}>DateTime</th>
        </tr>
        <tr style={{ backgroundColor: "#000", color: "white" }}>
          {["Dealer", "Bank", "Branch", "IFSC", "PAN", "Account"].map(h => (
            <th key={`old-${h}`} style={{ padding: "8px", fontSize: "13px" }}>{h}</th>
          ))}
          {["Dealer", "Bank", "Branch", "IFSC", "PAN", "Account"].map(h => (
            <th key={`new-${h}`} style={{ padding: "8px", fontSize: "13px" }}>{h}</th>
          ))}
        </tr>
      </thead>

      <tbody>
        {state.isMonthClosed ? (
          <>


            {state.records.map((r, i) => (
              <tr key={r.fpsId} >
                <td align="center" style={{ padding: "8px" }}>
                </td>
                <td align="center">{i + 1}</td>
                <td>{r.distNameEn || "NA"}</td>
                <td>{r.afsoNameEn || "NA"}</td>
                <td>{r.fpsId}</td>
                {[r.oldDealerName, r.oldBankName, r.oldBranchName, r.oldIfscCode, r.oldPanNo, r.oldAcNo].map((v, j) => (
                  <td key={`o${j}`}>{v || "NA"}</td>
                ))}
                {[r.newDealerName, r.newBankName, r.newBranchName, r.newIfscCode, r.newPanNo, r.newAcNo].map((v, j) => (
                  <td key={`n${j}`} >
                    <strong>{v || "NA"}</strong>
                  </td>
                ))}
                <td>{r.datatime || ""}</td>
              </tr>
            ))}
            <tr>
              <td colSpan="18" align="center" style={{
                padding: "20px",
                fontWeight: "bold",
                fontSize: "15px",
                color: "black"
              }}>
                Bank Approvals closed for this district
              </td>
            </tr>
          </>
        ) : state.records.length === 0 ? (
          <tr>
            <td colSpan="18" align="center" >
              No pending records found
            </td>
          </tr>
        ) : (
          state.records.map((r, i) => (
            <tr key={r.fpsId} style={{ backgroundColor: i % 2 === 0 ? "#f9f9f9" : "white" }}>
              <td align="center" style={{ padding: "8px" }}>
                {r.showCheckbox && (
                  <input type="checkbox" checked={selectedIds.includes(r.fpsId)} onChange={() => toggleOne(r.fpsId)} />
                )}
              </td>
              <td align="center">{i + 1}</td>
              <td>{r.distNameEn || "NA"}</td>
              <td>{r.afsoNameEn || "NA"}</td>
              <td>{r.fpsId}</td>
              {[r.oldDealerName, r.oldBankName, r.oldBranchName, r.oldIfscCode, r.oldPanNo, r.oldAcNo].map((v, j) => (
                <td key={`o${j}`}>{v || "NA"}</td>
              ))}
              {[r.newDealerName, r.newBankName, r.newBranchName, r.newIfscCode, r.newPanNo, r.newAcNo].map((v, j) => (
                <td key={`n${j}`} >
                  <strong>{v || "NA"}</strong>
                </td>
              ))}
              <td>{r.datatime || ""}</td>
            </tr>
          ))
        )}
      </tbody>

      <tfoot>
        <tr>
          <td colSpan="18" align="center" style={{ padding: "18px", backgroundColor: "#f0f0f0" }}>
            {!isMonthClosed && (
              <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
                {hasPendingForAction && (
                  <>
                    <button onClick={() => performAction("approve")}
                      className="button button2" >
                      Approve
                    </button>
                    <button onClick={() => selectedIds.length > 0 ? setShowRejectModal(true) : alert("Please select at least one record to reject.")}
                      className="button button2" >
                      Reject
                    </button>
                  </>
                )}
                <button onClick={handleCloseMonth}
                  className="button button2" >
                  Close for the Month
                </button>
              </div>
            )}
          </td>
        </tr>
      </tfoot>
    </table>
  );
}